module.exports = __webpack_public_path__ + "img/status-alt.1d7c1f00.svg";